import cx from "clsx"
import * as LocalIcons from "../../svg"
import * as ReactIcons from "../../icons"
import AntIcon, { LoadingOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import React from "react"
import styles from "./index.module.less"
import Tooltip from "../tooltip/tooltip"
import theme from "utils/themeVars"

function Icon(props) {
  const {
    icon,
    size,
    className,
    hasBackground,
    tooltipText,
    iconContainerStyle,
    flip,
    placement = "top",
    isLoading,
    overlayInnerStyle,
    ...rest
  } = props

  const Component = ReactIcons[icon] || LocalIcons[icon]

  const getIcon = () =>
    !!tooltipText ? (
      <Tooltip placement={placement} title={tooltipText} overlayInnerStyle={overlayInnerStyle}>
        <AntIcon
          className={cx(styles.icon, className)}
          component={() => (Component ? <Component size={size} {...rest} /> : null)}
        />
      </Tooltip>
    ) : (
      <AntIcon
        className={cx(styles.icon, className)}
        component={() => (Component ? <Component size={size} {...rest} /> : null)}
      />
    )

  const iconContent = () => (isLoading ? <LoadingOutlined style={{ fontSize: size, color: theme["primary-color"] }} size={size} {...rest} spin/> : getIcon())

  return hasBackground ? (
    <div className={styles.iconStyled} style={{ ...iconContainerStyle }}>
      {iconContent()}
    </div>
  ) : (
    iconContent()
  )
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Icon.defaultProps = {
  size: "1.2em",
}

export default Icon
